// ----------------------------------------

function isValidVariable(_variable) {
  let valid = false;
  if (typeof _variable !== 'undefined') {
    if (_variable !== 'null' && _variable !== null) {
      if (_variable !== '') {
        valid = true;
      }
    }
  }
  return valid;
}

function isValidInteger(_variable) {
  var valid = false;
  if (isValidVariable(_variable)) {
    if (parseInt(_variable) == _variable) {
      if (_variable > 0) {
        valid = true;
      }
    }
  }
  return valid;
}

function isValidEmail(_variable) {
  let valid = false;
  if (isValidVariable(_variable)) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    valid = re.test(String(_variable).toLowerCase());;
  }
  return valid;
}

function elementExists(_variable) {
  let valid = false;
  if (isValidVariable(_variable)) {
    if ($(_variable).length > 0) {
      valid = true;
    }
  }
  return valid;
}

function checkTouchDevice() {
  var check = false;
  (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
}

// slideshow
function initGallery() {

  var players = [];

  // Loop through the slides
  // $('#bannerGallery .swiper-slide').each(function (index) {
  //   var $overlay = $(this).find('.banner-media__overlay');

  //   var video = $(this).find('.banner-media__video');
  //   if (video.length) {
  //     // Init the video
  //     var plyr = new Plyr(video[0]);
  //     // Clicking to play the video
  //     // $overlay.on('click', function (e) {
  //     //   e.preventDefault();

  //     //   $(this).addClass('hidden');
  //     //   plyr.play();
  //     // });

  //     plyr.on('timeupdate', () => {
  //       console.log('Current time:', plyr.currentTime);
  //     });

  //     // Add the player to the players array
  //     players.push(plyr);
  //   }
  // });

  var plyr = null;

  var galleryTop = new Swiper('#bannerGallery', {
    autoHeight: false,
    slidesPerView: 1,
    allowTouchMove: false,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    // autoHeight: true,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
    // autoplay: true,
    breakpoints: {
      100: {
        autoplay: false,
      },
      768: {
        autoplay: {
          delay: 600 * 10,
        },
      },
    },
    // On slide change
    on: {
      slideChange: function (swiper) {
        console.log(Plyr.instances)
        // Pause the plyr instance
        if (plyr) {
          plyr.pause();
        }

        // Show all overlays
        $('#bannerGallery .swiper-slide .banner-media__overlay').removeClass('hidden');
      },
    },
  });

  galleryTop.emit('slideChange');

  $('#bannerGallery .swiper-slide').each(function (index) {
    var $overlay = $(this).find('.banner-media__overlay');
    var video = $(this).find('.banner-media__video');

    if (video.length) {
      $overlay.on('click', function (e) {
        e.preventDefault();

        $(this).addClass('hidden');
        plyr = new Plyr(video[0]);
        setTimeout(() => {
          plyr.play();
        }, 1000)
        plyr.on('ready', () => {
          plyr.play();
        });
      });
    }
  });
}

function initVoting() {
  // const swiper = new Swiper('.voting-container', {
  //   speed: 400,
  //   spaceBetween: 100,
  // });
}


function filterList() {
  // Declare variables
  var input, filter, ul, li, a, i, txtValue;
  input = document.getElementById('filterTag');
  filter = input.value.toUpperCase();
  ul = document.getElementById("tagList");
  li = ul.getElementsByTagName('li');

  // Loop through all list items, and hide those who don't match the search query
  for (i = 0; i < li.length; i++) {
    a = li[i];
    txtValue = a.textContent || a.innerText;
    if (txtValue.toUpperCase().indexOf(filter) > -1) {
      li[i].style.display = "";
    } else {
      li[i].style.display = "none";
    }
  }
};

function filterCats() {
  // Declare variables
  var input, filter, ul, li, a, i, txtValue;
  input = document.getElementById('filterCat');
  filter = input.value.toUpperCase();
  ul = document.getElementById("catList");
  li = ul.getElementsByTagName('li');

  // Loop through all list items, and hide those who don't match the search query
  for (i = 0; i < li.length; i++) {
    a = li[i];
    txtValue = a.textContent || a.innerText;
    if (txtValue.toUpperCase().indexOf(filter) > -1) {
      li[i].style.display = "";
    } else {
      li[i].style.display = "none";
    }
  }
};

function filterAuths() {
  // Declare variables
  var input, filter, ul, li, a, i, txtValue;
  input = document.getElementById('filterAuth');
  filter = input.value.toUpperCase();
  ul = document.getElementById("authList");
  li = ul.getElementsByTagName('li');

  // Loop through all list items, and hide those who don't match the search query
  for (i = 0; i < li.length; i++) {
    a = li[i];
    txtValue = a.textContent || a.innerText;
    if (txtValue.toUpperCase().indexOf(filter) > -1) {
      li[i].style.display = "";
    } else {
      li[i].style.display = "none";
    }
  }
};

/* 
** Filters the posts on the index page by tag, catergory, author.
*/
function filterPosts() {
  var currentTags = document.getElementById("qTags").innerHTML;
  var currentCats = document.getElementById("qCats").innerHTML;
  var currentAuths = document.getElementById("qAuthors").innerHTML;
  //var currentURL = location.href.replace(location.search, '');
  var currentURL = '/posts/';

  var trigger = event.target;

  var type = trigger.parentElement.getAttribute('id');
  var tag = trigger.innerHTML.toLowerCase().replace(/\s/g, '-');
  var cat = trigger.innerHTML.toLowerCase().replace(/\s/g, '-');
  var auth = trigger.dataset.id;
  var tags = [];
  var cats = [];
  var auths = [];

  // If has query fill array.

  if (currentTags) {
    tags = currentTags.split(",");
  }
  if (currentCats) {
    cats = currentCats.split(",");
  }
  if (currentAuths) {
    auths = currentAuths.split(",");
  }

  if (type == "tagList") {
    if (tags.includes(tag)) { // test if tag has already been selected
      tags = tags.filter(e => e !== tag); // remove tag from list
    }
    else {
      tags.push(tag);
    }
  }
  else if (type == "catList") {
    if (cats.includes(cat)) { // test if cat has already been selected
      cats = cats.filter(e => e !== cat); // remove cat from list
    }
    else {
      cats.push(cat);
    }
  }
  else if (type == "authList") {
    if (auths.includes(auth)) { // test if auth has already been selected
      auths = auths.filter(e => e !== auth); // remove cat from list
    }
    else {
      auths.push(auth);
    }
  }
  else {
    return (trigger);
  }

  // Build URL

  var tagsURL = "";
  var catsURL = "";
  var authsURL = "";
  if (tags.length !== 0) {
    tagsURL = tagsURL.concat("&tag=", tags.join(","));
  }
  if (cats.length !== 0) {
    catsURL = catsURL.concat("&category=", cats.join(","));
  }
  if (auths.length !== 0) {
    authsURL = authsURL.concat("&author=", auths.join(","));
  }
  var url = currentURL.concat("?", tagsURL, catsURL, authsURL);
  location.replace(url);

  console.log(tagsURL, catsURL, authsURL);
}



function togglePlayPause(button, overlay) {
  button.classList.toggle("pause");
  overlay.classList.toggle("active");
  if (overlay.classList.contains('active')) {
    button.innerHTML = "Pause video";
  } else {
    button.innerHTML = "Play video";
  }
}


window.addEventListener("hashchange", function () {
  window.scrollTo(window.scrollX, window.scrollY - 200);
});

function submissionsForm() {

  $(document).on('click', '.form-cards .form-card', function () {
    $('input[name="option"]').val($(this).data('option'));
    $('.form-cards .form-card.selected').removeClass('selected');
    $(this).addClass('selected');
  });

  // Handling success msg
  var urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('success') && urlParams.get('tier')) {
    $('.grm-submission-success').show().find('span').text('Payment successfully made. Thank you — we will be in touch.');
    $('html, body').animate({
      scrollTop: $('.grm-submission-success').offset().top
    }, 600);
  }
  if (urlParams.get('cancel') && urlParams.get('tier')) {
    $('.grm-submission-error').show().find('span').text('Payment cancelled. Please try again.');
    $('html, body').animate({
      scrollTop: $('.grm-submission-error').offset().top
    }, 600);
  }

  // Submit
  $('form.grm-submission-stripe').on('submit', function (e) {
    e.preventDefault();

    // Remove errors
    $(this).find('.form-error').removeClass('form-error');
    $('.grm-submission-success').removeClass('show').find('span').text('');
    $('.grm-submission-error').removeClass('show').find('span').text('');

    // Catch errors
    var errors = false;
    $(this).find('.form-group.required').each(function () {
      if (!$(this).find('input').val().length || ($(this).find('input').is(':checkbox') && !$(this).find('input').is(':checked'))) {
        errors = true;
        $(this).addClass('form-error');
      }
    });

    if (!errors) {
      var formData = new FormData($(this)[0]);
      formData.append('action', 'grm_submission_form');
      $.ajax({
        url: '/wp-admin/admin-ajax.php',
        type: 'post',
        processData: false,
        contentType: false,
        cache: false,
        data: formData,
        beforeSend: function () {
          $('.grm-submission-success, .grm-submission-error').removeClass('show').find('span').text('');
          $(this).find('#submit').attr('disabled', true).text('Loading...');
        },
        success: function (response) {
          if (response.url) {
            location.href = response.url;
          } else {
            if (response.error) {
              if (response.validation.length) {
                $.each(response.validation, function (index, name) {
                  $('input[name="' + name + '"').parents('div.form-group').addClass('form-error');
                });
              }
            } else {
              // Default error msg
              $('.grm-submission-error').addClass('show').find('span').text('There has been error with Stripe. Please try again later.');
            }
          }
        }
      });
    }
  });
}

function newsletterForm() {
  $('form.newsletter').on('submit', function (e) {
    e.preventDefault();

    var $form = $(this);

    $.ajax({
      url: grmSettings.ajax,
      type: 'post',
      data: {
        action: 'grm_newsletter',
        email_address: $(this).find('input[name="email_address"]').val()
      },
      beforeSend: function (e) {
        $('.form__message').remove();
        $form.attr('disabled', true);
      },
      success: function (response) {
        var color = response.success ? 'inherit' : '#E53935';
        $form.append(`<p class="form__message" style="color: ${color}">${response.data.message}</p>`);

        if (response.success) {
          $('.newsletter__fields, .newsletter__tcs').remove();
        } else {
          $form.attr('disabled', false);
        }
      }
    })
  });

  // Follow on scroll, pin to top of screen
  var $newsletter = $('.newsletter');
  if ($(window).width() > 1200 && $newsletter.length) {
    var top = $newsletter.offset().top;
    var height = $newsletter.height();
    var width = $newsletter.width();

    $newsletter.css('width', width + 60);

    $(window).on('scroll', function () {
      // Detect when the user has scrolled to the top of the newsletter
      var scroll = $(window).scrollTop();
      if (scroll > (top + height)) {
        $newsletter.addClass('newsletter--fixed');
      } else {
        $newsletter.removeClass('newsletter--fixed');
      }
    });
  }
}

function loadMore() {
  var paged = 1;

  $('.post-feed__load-more').on('click', function (e) {
    e.preventDefault();

    var term_id = $(this).data('term') || '';

    paged++;

    $.ajax({
      url: grmSettings.ajax,
      type: 'post',
      data: {
        action: 'grm_load_more',
        term_id: term_id,
        paged: paged
      },
      beforeSend: function () {
        $('.post-feed__load-more').attr('disabled', true);
      },
      success: function (response) {

        $('.post-feed__posts').append(response.data.posts);

        if (paged >= response.data.max) {
          $('.post-feed__load-more').hide();
        } else {
          $('.post-feed__load-more').attr('disabled', false);
        }
      }
    });
  });
}


// ----------------------------------------

jQuery(document).ready(function () {

  submissionsForm();
  newsletterForm();
  loadMore();

  // Select the button
  const btn = document.querySelector("#dark-mode");
  btn.removeAttribute("disabled");
  // Listen for a click on the button 
  btn.addEventListener("input", (e) => {
    const isChecked = e.target.checked;

    // Toggle the .dark-theme class on the body
    document.body.classList.toggle("light-theme");

    // Let's say the theme is equal to dark
    let theme = "dark";
    // If the body contains the .light-theme class...
    if (document.body.classList.contains("light-theme")) {
      // ...then let's make the theme dark
      theme = "light";
    }
    // Then save the choice in a cookie
    var now = new Date();
    now.setTime(now.getTime() + 1 * 3600 * 1000);
    var newCookie = 'theme=' + theme + '; expires=' + now.toUTCString() + '; path=/;'
    document.cookie = newCookie;

  });


  // setTimeout(initGallery(), 5000);
  initGallery();

  // Pause videos on slide change.
  jQuery('.icon-slide-control').click(function () {
    jQuery('.__youtube_prefs__').each(function () {
      this.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
    });
  });

  // wow
  let wow = new WOW({
    boxClass: 'wow',
    animateClass: 'animated',
    offset: 100,
    mobile: true,
    live: true,
  });
  wow.init();

});
// players = initPlayers();